import { Directive, ElementRef, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { Gesture}  from 'ionic-angular';
declare var Hammer: any;

@Directive({
  selector: '[swipe-vertical]'
})
export class SwipeVertical implements OnInit, OnDestroy {
  @Output('swipeStart') swipeStart: EventEmitter<any> = new EventEmitter();
  @Output('swiping') swiping: EventEmitter<any> = new EventEmitter();
  @Output('swipeEnd') swipeEnd: EventEmitter<any> = new EventEmitter();

  @Output('swipeUp') swipeUp: EventEmitter<any> = new EventEmitter();
  @Output('swipeDown') swipeDown: EventEmitter<any> = new EventEmitter();

  private el: HTMLElement;
  private swipeGesture: Gesture;

  constructor(el: ElementRef) {
    this.el = el.nativeElement
  }

  ngOnInit() {
    this.swipeGesture = new Gesture(this.el, {
      recognizers: [
        [Hammer.Pan, {direction: Hammer.DIRECTION_VERTICAL}],
        [Hammer.Swipe, {direction: Hammer.DIRECTION_VERTICAL}]
      ]
    });
    this.swipeGesture.listen();
    this.swipeGesture.on('panstart', e => {
      this.swipeStart.emit(e);
    });
    this.swipeGesture.on('panmove', e => {
      this.swiping.emit(e);
    });
    this.swipeGesture.on('panend', e => {
      this.swipeEnd.emit(e);
      if (e.deltaY < -100) this.swipeUp.emit(e);
      if (e.deltaY > 100) this.swipeDown.emit(e);
    });
  }

  ngOnDestroy() {
    this.swipeGesture.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/directives/swipe-vertical.directive.ts